import ManualSeatInput from './ManualSeatInput.vue';

export default ManualSeatInput;
